import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { layoutSliceActions } from "../redux/features/layout/layout.slice";
import { useAppSelector } from "../redux/hooks";

const isWhitelistedPath = (path: string) => {
  return [
    "/app/settings",
    "/app/settings/profile/edit",
    "/app/overview",
    "/app/settings?tab=bank_account",
    "/app/settings?tab=profile",
  ].includes(path);
};

export const useLayout = () => {
  const [canClosePopup, setCanClosePopup] = useState<boolean>(false);

  const { onboardingCompletionStatus, profile } = useAppSelector((state) => {
    return state.auth;
  });

  const location = useLocation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const setPopupOpen = (value: boolean) => {
    dispatch(layoutSliceActions.onboardingPopupChanged(value));
  };

  const closePopup = () => {
    if (
      !isWhitelistedPath(location.pathname) &&
      profile?.type === "member" &&
      !onboardingCompletionStatus?.isAllComplete
    ) {
      navigate("/app/overview");
      return;
    } else {
      setPopupOpen(false);
    }
  };

  useEffect(() => {
    if (
      !isWhitelistedPath(location.pathname) &&
      profile?.type === "member" &&
      !onboardingCompletionStatus?.isAllComplete
    ) {
      setCanClosePopup(false);
    } else {
      setCanClosePopup(true);
    }
  }, [location.pathname, profile, onboardingCompletionStatus]);

  return {
    setPopupOpen,
    closePopup,
    isWhitelistedPath,
    canClosePopup,
  };
};
